module.exports = __webpack_public_path__ + "static/media/8_r_tank_78.18_78.89.79663909.png";